<template>
	<div>
		<div class="nav_bar">
			<van-nav-bar
				title="地址簿"
				left-arrow
				@click-left="$router.go(-1)"
			/>
		</div>
		<div style="height: 46px;"></div>
		<div class='address' v-if="showList">
			<div v-for="item in list" class='address_list ui-flex' @click="edit(item.id)">
				<div class='ui-flex-1'>
					<div class='receiveName'>
						<b>{{item.receiverName}}</b>
						<span>{{item.receiverPhone}}</span>
						<van-tag type="warning" round v-if="item.addressStatus > 0">默认</van-tag>
					</div>
					<div class='address_info'>
						{{item.receiverProvince == item.receiverCity ? item.receiverCity:item.receiverProvince + item.receiverCity}}{{item.receiverRegion}}{{item.receiverAddress}}
					</div>
				</div>
				<div class='address_edit_icon'>
					<van-icon name="edit" size="18" color="#999"/>
				</div>
			</div>
		</div>
		<van-empty v-else description="暂无数据" />

		<div style='height:96px;'></div>
		<div class='bottom_fixed'>
			<van-button type="primary" color="#2f86f6" icon="plus" round block to="/home/address/add">添加</van-button>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list : [],
				showList : true
			};
		},
		mounted() {
			this.getList();
		},
		methods: {
			getList() {
				this.$toast.loading({
					message: '请求中...',
					forbidClick: true,
					duration : 0
				});
				this.$get("/gtb/home/listInvoiceReceiverInfo.html").then(res => {
					this.$toast.clear();
					if( res.success ){
						var list = res.listInvoiceReceiver;
						this.list =list;
						this.showList = list.length > 0;
					}
				}).catch(error=>{
					this.$toast.clear();
				});
			},
			edit(id){
				this.$router.push('/home/address/edit?id=' + id);
			}
		},
	};
</script>

<style scoped>
	.address{ position: relative; padding: 16px;}
	.address_list{ padding: 16px;background: #fff;position: relative; margin-bottom: 10px; border-radius: 9px;}
	.receiveName{ font-size: 16px;display:flex;align-items: center;}
	.receiveName span{ margin-left: 6px;}
	.address_info{ padding-top: 4px; color: #888;font-size: 12px;}
	.address_edit_icon{ display:flex;align-items: center;}
	
	.bottom_fixed{ position: fixed; width: 100%; bottom: 0; padding: 16px;}
</style>
